/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DossierNote,
  GetClientsParams,
  GetExpertParams,
  GetExpertsParams,
  GetPsychologistClientsParams,
  ModelsExternalQuestionnaire,
  ModelsQuestionsQuestionList,
  ModelsTag,
  ModelsTagType,
  ModelsTheme,
  RequestClientCreateRequest,
  RequestClientUpdateRequest,
  RequestConsultCreateRequest,
  RequestConsultUpdateRequest,
  ResponseConsultsConsultWithNotesResponse,
  ResponseConsultsConsultWithShortNotesResponse,
  ResponseHostClientWithRelationshipResponse,
  ResponsePsychologistClientResponse,
  ResponsePsychologistClientResponsePaginated,
  ResponsePsychologistConsultResponse,
  ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse,
  ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponsePaginated,
  ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse,
  ResponseVitalityCheckinVitalityCheckinModuleScoreResponse,
  SetConsultTagsPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Clients<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Clients
   * @name AnonymizeClient
   * @summary Anonymize a user based on their ID. This action is irreversible (Auth policies: SupportPolicy)
   * @request DELETE:/api/v1/clients/{userId}/anonymize
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  anonymizeClient = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/clients/${userId}/anonymize`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name CreateClient
   * @summary Allow a psychologist to create a new client/user (Auth policies: HostOrExpertPolicy)
   * @request POST:/api/v1/clients
   * @secure
   * @response `200` `ResponsePsychologistClientResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createClient = (
    data: RequestClientCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistClientResponse, void>({
      path: `/api/v1/clients`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name CreateConsult
   * @summary Allow a psychologist to create a new consult for a user (Auth policies: HostOrExpertPolicy)
   * @request POST:/api/v1/clients/{clientId}/consults
   * @secure
   * @response `200` `ResponsePsychologistConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createConsult = (
    clientId: string,
    data: RequestConsultCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistConsultResponse, void>({
      path: `/api/v1/clients/${clientId}/consults`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalQuestionnaires
   * @name CreateExternalQuestionnaires
   * @summary Allow a psychologist to create an external questionnaire for a user (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/clients/{clientId}/external-questionnaires
   * @secure
   * @response `200` `ModelsExternalQuestionnaire` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createExternalQuestionnaires = (
    clientId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsExternalQuestionnaire, void>({
      path: `/api/v1/clients/${clientId}/external-questionnaires`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name DeleteUserSessionTranscriptions
   * @summary Delete all call transcriptions for sessions of a specific user/client (Auth policies: HostOrSupportOrManagingPsychologistPolicy)
   * @request DELETE:/api/v1/clients/{userId}/transcriptions
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  deleteUserSessionTranscriptions = (
    userId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/clients/${userId}/transcriptions`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetClientById
   * @summary Get a user by user ID, a GUID (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/clients/{userId}
   * @secure
   * @response `200` `ResponseHostClientWithRelationshipResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientById = (userId: string, params: RequestParams = {}) =>
    this.http.request<ResponseHostClientWithRelationshipResponse, void>({
      path: `/api/v1/clients/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetClientCheckinResultsForTheme
   * @summary Get an overview of all checkins for the specified client for the specified theme (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{userId}/themes/{themeKey}
   * @secure
   * @response `200` `ModelsTheme` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientCheckinResultsForTheme = (
    userId: string,
    themeKey: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsTheme, void>({
      path: `/api/v1/clients/${userId}/themes/${themeKey}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetClientConsults
   * @summary Get all the consults for a given user (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/consults
   * @secure
   * @response `200` `(ResponseConsultsConsultWithShortNotesResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientConsults = (clientId: string, params: RequestParams = {}) =>
    this.http.request<ResponseConsultsConsultWithShortNotesResponse[], void>({
      path: `/api/v1/clients/${clientId}/consults`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetClientConsultWithNotes
   * @summary Get the consult for a given client (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/consults/session-notes/{consultId}
   * @secure
   * @response `200` `ResponseConsultsConsultWithNotesResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientConsultWithNotes = (
    consultId: number,
    clientId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseConsultsConsultWithNotesResponse, void>({
      path: `/api/v1/clients/${clientId}/consults/session-notes/${consultId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DossierNote
   * @name GetClientDossierNote
   * @summary Allow a psychologist to get a dossier's notes (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/dossier-note
   * @secure
   * @response `200` `DossierNote` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientDossierNote = (clientId: string, params: RequestParams = {}) =>
    this.http.request<DossierNote, void>({
      path: `/api/v1/clients/${clientId}/dossier-note`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetClients
   * @summary Get a list of all clients matching the search parameters (Auth policies: HostOrSupportOrManagingPsychologistPolicy)
   * @request GET:/api/v1/clients
   * @secure
   * @response `200` `ResponsePsychologistClientResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClients = (query: GetClientsParams, params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistClientResponsePaginated, void>({
      path: `/api/v1/clients`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetClientTags
   * @summary Get tags and tag types of the specified user (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/clients/{userId}/tags
   * @secure
   * @response `200` `(ModelsTag)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientTags = (userId: string, params: RequestParams = {}) =>
    this.http.request<ModelsTag[], void>({
      path: `/api/v1/clients/${userId}/tags`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetClientVitalityCheckinResultsForTheme
   * @summary  (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{userId}/vitality-checkin-results/{themeKey}
   * @secure
   * @response `200` `ResponseVitalityCheckinVitalityCheckinModuleScoreResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientVitalityCheckinResultsForTheme = (
    userId: string,
    themeKey: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponseVitalityCheckinVitalityCheckinModuleScoreResponse,
      void
    >({
      path: `/api/v1/clients/${userId}/vitality-checkin-results/${themeKey}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetClientVitalityCheckinResultsSummary
   * @summary  (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{userId}/vitality-checkin-results-summary
   * @secure
   * @response `200` `(ResponseVitalityCheckinVitalityCheckinModuleScoreResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientVitalityCheckinResultsSummary = (
    userId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponseVitalityCheckinVitalityCheckinModuleScoreResponse[],
      void
    >({
      path: `/api/v1/clients/${userId}/vitality-checkin-results-summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetClosestClientConsult
   * @summary  (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/consults/closest-consult
   * @secure
   * @response `200` `ResponsePsychologistConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClosestClientConsult = (clientId: string, params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistConsultResponse, void>({
      path: `/api/v1/clients/${clientId}/consults/closest-consult`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetConsultNotes
   * @summary Allow a psychologist to get the notes of a given consult (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/consults/{consultId}/notes
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getConsultNotes = (
    consultId: number,
    clientId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/clients/${clientId}/consults/${consultId}/notes`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetConsultTags
   * @summary Allow a psychologist to get the tags assigned to a consult (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/consults/{consultId}
   * @secure
   * @response `200` `(ModelsTagType)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getConsultTags = (
    consultId: number,
    clientId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsTagType[], void>({
      path: `/api/v1/clients/${clientId}/consults/${consultId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetConsultTags2
   * @summary Allow a psychologist to get the tags of a given type assigned to a consult (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/consults/{consultId}/{tagType}
   * @originalName getConsultTags
   * @duplicate
   * @secure
   * @response `200` `(ModelsTag)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getConsultTags2 = (
    consultId: number,
    tagType: string,
    clientId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsTag[], void>({
      path: `/api/v1/clients/${clientId}/consults/${consultId}/${tagType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetExpert
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/clients/psychologists/profile/{personalUrlHandle}
   * @secure
   * @response `200` `ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExpert = (
    { personalUrlHandle, ...query }: GetExpertParams,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse,
      void
    >({
      path: `/api/v1/clients/psychologists/profile/${personalUrlHandle}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetExperts
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/clients/psychologists
   * @secure
   * @response `200` `ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExperts = (query: GetExpertsParams, params: RequestParams = {}) =>
    this.http.request<
      ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponsePaginated,
      void
    >({
      path: `/api/v1/clients/psychologists`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalQuestionnaires
   * @name GetExternalQuestionnaires
   * @summary Allow a psychologist to get a user's external questionnaires (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{clientId}/external-questionnaires
   * @secure
   * @response `200` `(ModelsExternalQuestionnaire)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExternalQuestionnaires = (clientId: string, params: RequestParams = {}) =>
    this.http.request<ModelsExternalQuestionnaire[], void>({
      path: `/api/v1/clients/${clientId}/external-questionnaires`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistByEmail
   * @summary Get a single user with the psychologist role by ID, a GUID
   * @request GET:/api/v1/clients/psychologists/email/{email}
   * @secure
   * @response `200` `ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse` OK
   */
  getPsychologistByEmail = (email: string, params: RequestParams = {}) =>
    this.http.request<
      ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse,
      any
    >({
      path: `/api/v1/clients/psychologists/email/${email}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistById
   * @summary Get a single user with the psychologist role by ID, a GUID
   * @request GET:/api/v1/clients/psychologists/{userId}
   * @secure
   * @response `200` `ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse` OK
   */
  getPsychologistById = (userId: string, params: RequestParams = {}) =>
    this.http.request<
      ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse,
      any
    >({
      path: `/api/v1/clients/psychologists/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistByUrlHandle
   * @summary Get a single user with the psychologist role by ID, a GUID
   * @request GET:/api/v1/clients/psychologists/url-handle/{urlHandle}
   * @secure
   * @response `200` `ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse` OK
   */
  getPsychologistByUrlHandle = (
    urlHandle: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse,
      any
    >({
      path: `/api/v1/clients/psychologists/url-handle/${urlHandle}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetPsychologistClients
   * @summary Get a list of current logged in psychologist's clients matching the search parameters (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/my
   * @secure
   * @response `200` `ResponsePsychologistClientResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getPsychologistClients = (
    query: GetPsychologistClientsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistClientResponsePaginated, void>({
      path: `/api/v1/clients/my`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistTags
   * @summary Returns the tags relevant to the psychologist (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/clients/psychologists/psychologist-tags/{userId}
   * @secure
   * @response `200` `(ModelsTag)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getPsychologistTags = (userId: string, params: RequestParams = {}) =>
    this.http.request<ModelsTag[], void>({
      path: `/api/v1/clients/psychologists/psychologist-tags/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetUserMedicalCheckinResults
   * @summary Returns the medical check-in results of a client (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{userId}/medical-themes
   * @secure
   * @response `200` `(ModelsTheme)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserMedicalCheckinResults = (userId: string, params: RequestParams = {}) =>
    this.http.request<ModelsTheme[], void>({
      path: `/api/v1/clients/${userId}/medical-themes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name GetUserQuestionListAnswers
   * @summary Get results for a specific question list (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/clients/{userId}/question-list-answers/{questionListKey}
   * @secure
   * @response `200` `(ModelsQuestionsQuestionList)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserQuestionListAnswers = (
    userId: string,
    questionListKey: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ModelsQuestionsQuestionList[], void>({
      path: `/api/v1/clients/${userId}/question-list-answers/${questionListKey}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name RemoveTwoFactorFromUser
   * @summary Remove 2FA from a user (Auth policies: SupportPolicy)
   * @request PATCH:/api/v1/clients/{userId}/remove-2fa
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  removeTwoFactorFromUser = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/clients/${userId}/remove-2fa`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name SetConsultTags
   * @summary Allow a psychologist to assign tags to a consult (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/clients/{clientId}/consults/{consultId}/{tagType}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setConsultTags = (
    consultId: number,
    tagType: string,
    clientId: string,
    data: SetConsultTagsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/clients/${clientId}/consults/${consultId}/${tagType}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name UnlockUser
   * @summary  (Auth policies: SupportPolicy)
   * @request PUT:/api/v1/clients/{userId}/unlock
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  unlockUser = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/clients/${userId}/unlock`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Clients
   * @name UpdateClient
   * @summary Allow a psychologist to update a client/user (Auth policies: ExpertPolicy)
   * @request PUT:/api/v1/clients/{userId}
   * @secure
   * @response `200` `ResponsePsychologistClientResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateClient = (
    userId: string,
    data: RequestClientUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistClientResponse, void>({
      path: `/api/v1/clients/${userId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DossierNote
   * @name UpdateClientDossierNote
   * @summary Allow a psychologist to assign a note to a dossier (Auth policies: ExpertPolicy)
   * @request PUT:/api/v1/clients/{clientId}/dossier-note
   * @secure
   * @response `200` `DossierNote` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateClientDossierNote = (
    clientId: string,
    data: DossierNote,
    params: RequestParams = {},
  ) =>
    this.http.request<DossierNote, void>({
      path: `/api/v1/clients/${clientId}/dossier-note`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name UpdateConsult
   * @summary Allow a psychologist to update a consult (Auth policies: ExpertPolicy)
   * @request PUT:/api/v1/clients/{clientId}/consults/{consultId}
   * @secure
   * @response `200` `ResponsePsychologistConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateConsult = (
    consultId: number,
    clientId: string,
    data: RequestConsultUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistConsultResponse, void>({
      path: `/api/v1/clients/${clientId}/consults/${consultId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name UpdateConsultTheme
   * @summary Update the theme for a consult (Auth policies: ExpertPolicy)
   * @request PATCH:/api/v1/clients/{clientId}/consults/{consultId}/theme/{themeKey}
   * @secure
   * @response `200` `ResponsePsychologistConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateConsultTheme = (
    consultId: number,
    themeKey: string,
    clientId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistConsultResponse, void>({
      path: `/api/v1/clients/${clientId}/consults/${consultId}/theme/${themeKey}`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
}
